(() => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;
        if (target.classList.contains('is-visible') && target.classList.contains('quick-product--wrap')) {
          setTimeout(() => {
            if (window.Abra && window.Abra.render) {
              window.Abra.render();
            }
          }, 800);
        }
      }
    });
  });

  const modal = document.querySelector('.quick-product--wrap');
  if (modal) {
    observer.observe(modal, { attributes: true, attributeFilter: ['class'] });
  }
})();

// Drawer Custom Events and Cart Auto-Refresh
(() => {
  const initFreeShippingBar = (node) => {
    if (!node) return;
    
    const threshold = parseInt(node.dataset.threshold, 10);
    const cartTotal = parseInt(node.dataset.cartTotal, 10);
    const successMessage = node.dataset.freeShippingSuccessMessage;
    const pendingMessage = node.dataset.freeShippingPendingMessage;
    const thresholdInCents = threshold * 100;
    
    const messageEl = node.querySelector('.free-shipping-bar__message');
    const progressBar = node.querySelector('.free-shipping-bar__bar-progress');
    
    if (!messageEl || !progressBar) return;
    
    if (cartTotal >= thresholdInCents) {
      node.classList.add('free-shipping-bar--success');
      messageEl.innerText = successMessage;
    } else {
      const remainder = Math.abs(cartTotal - thresholdInCents);
      const remainingFormatted = `$${(remainder / 100).toFixed(2)}`;
      messageEl.innerHTML = pendingMessage.replace('{{ remaining_amount }}', `<span class="fs-body-bold">${remainingFormatted}</span>`);
    }
    
    const progress = cartTotal < thresholdInCents ? (cartTotal / threshold) : 100;
    progressBar.parentElement.style.setProperty('--progress-width', `${progress}%`);
    node.classList.add('free-shipping-bar--loaded');
  };

  window.refreshQuickCart = function() {
    const quickCart = document.querySelector('[data-section-type="quick-cart"]');
    if (!quickCart) return;
    
    fetch(window.Shopify.routes.root + 'cart?section_id=quick-cart')
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newContainer = doc.querySelector('.quick-cart__container');
        const currentContainer = quickCart.querySelector('.quick-cart__container');
        
        if (newContainer && currentContainer) {
          currentContainer.innerHTML = newContainer.innerHTML;
          
          const freeShippingBar = currentContainer.querySelector('[data-free-shipping-bar]');
          if (freeShippingBar) {
            initFreeShippingBar(freeShippingBar);
          }
        }
      });
  };

  document.addEventListener('abra:refresh-quick-cart', function() {
    window.refreshQuickCart();
  });

document.addEventListener('cart:item-added', function(e) {
  const customEvent = new CustomEvent('abra:cart-item-added', {
    detail: e.detail
  });
  document.dispatchEvent(customEvent);
});

  document.addEventListener('cart:updated', function(e) {
    const customEvent = new CustomEvent('abra:cart-updated', {
      detail: e.detail
    });
    document.dispatchEvent(customEvent);
  });

  let previousCartItemCount = null;

  const checkCartChanges = () => {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(res => res.json())
      .then(cart => {
        if (previousCartItemCount !== null) {
          if (cart.item_count < previousCartItemCount) {
            const customEvent = new CustomEvent('abra:cart-item-removed', {
              detail: { cart }
            });
            document.dispatchEvent(customEvent);
          }
        }
        previousCartItemCount = cart.item_count;
      });
  };

  document.addEventListener('cart:updated', checkCartChanges);

  let isRefreshing = false;
  let refreshTimeout = null;

  const triggerCartRefresh = () => {
    if (isRefreshing) return;
    
    if (refreshTimeout) {
      clearTimeout(refreshTimeout);
    }

    refreshTimeout = setTimeout(() => {
      isRefreshing = true;
      document.dispatchEvent(new CustomEvent('abra:refresh-quick-cart'));
      
      setTimeout(() => {
        isRefreshing = false;
      }, 2000);
    }, 2500);
  };

  document.addEventListener('click', (e) => {
    const target = e.target.closest('[data-subtract-quantity], [data-add-quantity], [data-remove-item]');
    if (target) {
      const removeButton = e.target.closest('[data-remove-item]');
      if (removeButton) {
        document.dispatchEvent(new CustomEvent('abra:cart-remove-clicked'));
      }
      triggerCartRefresh();
    }
  });

  document.addEventListener('abra:cart-item-added', () => {
    triggerCartRefresh();
  });

  document.addEventListener('abra:cart-item-removed', () => {
    triggerCartRefresh();
  });
})();

// Cart Page Events and Auto-Refresh
(() => {
  const isCartPage = () => window.location.pathname.includes('/cart');
  
  if (!isCartPage()) return;

  const initFreeShippingBarCartPage = (node) => {
    if (!node) return;
    
    const threshold = parseInt(node.dataset.threshold, 10);
    const cartTotal = parseInt(node.dataset.cartTotal, 10);
    const successMessage = node.dataset.freeShippingSuccessMessage;
    const pendingMessage = node.dataset.freeShippingPendingMessage;
    const thresholdInCents = threshold * 100;
    
    const messageEl = node.querySelector('.free-shipping-bar__message');
    const progressBar = node.querySelector('.free-shipping-bar__bar-progress');
    
    if (!messageEl || !progressBar) return;
    
    if (cartTotal >= thresholdInCents) {
      node.classList.add('free-shipping-bar--success');
      messageEl.innerText = successMessage;
    } else {
      const remainder = Math.abs(cartTotal - thresholdInCents);
      const remainingFormatted = `$${(remainder / 100).toFixed(2)}`;
      messageEl.innerHTML = pendingMessage.replace('{{ remaining_amount }}', `<span class="fs-body-bold">${remainingFormatted}</span>`);
    }
    
    const progress = cartTotal < thresholdInCents ? (cartTotal / threshold) : 100;
    progressBar.parentElement.style.setProperty('--progress-width', `${progress}%`);
    node.classList.add('free-shipping-bar--loaded');
  };

  window.refreshCartPage = function() {
    const cartPage = document.querySelector('[data-section-type="cart"]');
    if (!cartPage) return;
    
    const sectionId = cartPage.dataset.sectionId;
    if (!sectionId) return;
    
    fetch(window.Shopify.routes.root + `cart?section_id=${sectionId}`)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newCartPage = doc.querySelector('[data-section-type="cart"]');
        
        if (newCartPage && cartPage) {
          cartPage.innerHTML = newCartPage.innerHTML;
          
          const freeShippingBar = cartPage.querySelector('[data-free-shipping-bar]');
          if (freeShippingBar) {
            initFreeShippingBarCartPage(freeShippingBar);
          }
        }
      });
  };

  document.addEventListener('abra:refresh-cart-page', function() {
    window.refreshCartPage();
  });

  let isRefreshing = false;
  let refreshTimeout = null;

  const triggerCartPageRefresh = (delay = 2000) => {
    if (isRefreshing) return;
    
    if (refreshTimeout) {
      clearTimeout(refreshTimeout);
    }

    refreshTimeout = setTimeout(() => {
      isRefreshing = true;
      document.dispatchEvent(new CustomEvent('abra:refresh-cart-page'));
      
      setTimeout(() => {
        isRefreshing = false;
      }, 2000);
    }, delay);
  };

  document.addEventListener('click', (e) => {
    const addButton = e.target.closest('[data-add-quantity]');
    const subtractButton = e.target.closest('[data-subtract-quantity]');
    const removeButton = e.target.closest('[data-remove-item]');
    
    if (addButton) {
      const cartItem = addButton.closest('.cart__form-item');
      if (cartItem) {
        document.dispatchEvent(new CustomEvent('abra:cart-page-add-clicked'));
        triggerCartPageRefresh(2000);
        setTimeout(() => triggerCartPageRefresh(3000), 100);
      }
    }
    
    if (subtractButton) {
      const cartItem = subtractButton.closest('.cart__form-item');
      if (cartItem) {
        document.dispatchEvent(new CustomEvent('abra:cart-page-subtract-clicked'));
        triggerCartPageRefresh(2000);
        setTimeout(() => triggerCartPageRefresh(3000), 100);
      }
    }
    
    if (removeButton) {
      const cartItem = removeButton.closest('.cart__form-item');
      if (cartItem) {
        document.dispatchEvent(new CustomEvent('abra:cart-page-remove-clicked'));
        triggerCartPageRefresh(2000);
        setTimeout(() => triggerCartPageRefresh(3000), 100);
      }
    }
  });

  document.addEventListener('abra:cart-page-add-clicked', () => {
  });

  document.addEventListener('abra:cart-page-subtract-clicked', () => {
  });

  document.addEventListener('abra:cart-page-remove-clicked', () => {
  });
})();